const Builder = require('./BuilderBase');
const HiddenFor = require('./HiddenFor');
const ShortText = require('./formElements/ShortText');

module.exports = class WorkflowActionPane extends Builder {
    constructor(title = 'WorkflowActionPane', properties) {
        super('workflowPane_WorkflowActionPane', title, properties);
        if (!properties.action) {
            throw new Error('For Workflow Action Panes you must specify an action');
        }
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }

    shortText(title, properties) {
        let shortText = new ShortText(title, properties);
        this.addChildBlock(shortText);
        return shortText;
    }
};
